import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useConsent} from "../context/ConsentContext";

const ConsentBanner = () => {
    const { grantConsent } = useConsent();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consentGiven = localStorage.getItem('user_consent') === 'true';
        if (!consentGiven) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        grantConsent();
        setIsVisible(false);
    };

    const handleDecline = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="fixed bottom-0 left-0 w-full bg-gray-900 text-white p-4 shadow-lg z-50 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-center md:text-left">
                Per utilizzare tutte le funzionalità, come la scansione, è necessario accettare la nostra{' '}
                <Link to="/privacy-policy" className="text-blue-400 underline hover:text-blue-300">
                    Privacy Policy
                </Link> che include la raccolta di dati di navigazione.
            </p>
            <div className="flex items-center gap-3">
                <button
                    onClick={handleDecline}
                    className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-300 whitespace-nowrap"
                >
                    Rifiuta
                </button>
                <button
                    onClick={handleAccept}
                    className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-300 whitespace-nowrap"
                >
                    Accetto
                </button>
            </div>
        </div>
    );
};

export default ConsentBanner;